module.exports = __webpack_public_path__ + "img/QPA_standard_logo.dcf4674e.png";